<template>
  <svg
    width="38"
    height="30"
    viewBox="0 0 38 30"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.2228 8.35038V0L30.3044 9.08161L37.5859 16.3631L30.1752 22.5391L21.2228 30V21.8291C5.50606 20.6444 -0.000400543 29.7395 -0.000400543 29.7395C-0.000400543 24.0729 0.466511 18.1922 4.92146 13.7391C10.0999 8.55875 17.5994 8.19217 21.2228 8.35038Z"
      fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: "ShareIcon",
  props: {
    fill: {
      type: String,
      default: '#3A913F'
    }
  }
}
</script>
